<template>
  <base-section
    id="autoshop"
    space="50">
<v-container class="mt-2 grey lighten-3">
      <base-section-heading title="Bengkel Rekanan" />
      <v-card>
      <v-card-title>
      <v-text-field
        v-model="searchautoshop"
        append-icon="mdi-magnify"
        label="Cari Bengkel Rekanan"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
      <v-data-table
	    :headers="headersautoshop"
	    :items="autoshop"
	    :search="searchautoshop"
	    item-key="branch_name"
	    class="elevation-1"
	  >
	  <template v-slot:item.care_address1="{ item }">
        {{ item.care_address1 }} {{ item.care_address2 }} {{ item.care_address3 }} <a :href="`https://maps.google.com/maps?q=${item.care_latitude},${item.care_longitude}`" target="blank">Lokasi</a>
       </template>
	  </v-data-table>
	</v-card>
    </v-container>
    </base-section>
  </template>
  <script>
  export default {
    name: 'SectionAutoShop',
    data: () => ({
      searchautoshop: '',	
      autoshop: [],
      headersautoshop: [
        {
          text: 'Kota',
          align: 'start',
          value: 'care_city',
          class: "secondary white--text body-1",
          width: '20%'
        },
        { text: 'Bengkel Rekanan', value: 'care_name',class: "secondary white--text body-1" },
        { text: 'Address', value: 'care_address1',class: "secondary white--text body-1" },
        { text: 'PIC', value: 'care_pic',class: "secondary white--text body-1" },
      ],
    }),
    created () {
    	this.AutoShop()
    },
    methods: {
        AutoShop () {
          let formdata = {
                branch_actived: 'Y',
                order_by: 'ID',
                order_type: 'ASC',
          }
          let param      = this.$functions.ParamPOST(formdata)
          this.$axios.post(this.$functions.UrlPOST('apiWebAutoShopList'),param,{
          headers: {
              'Content-Type': 'text/plain; charset=ISO-8859-1'
          }
          })
          .then(response => {
              this.autoshop = response.data
          })
          .catch(e => {
              alert(e)
          })
        },
    }
  }
</script>
<style>
tbody tr:nth-of-type(odd) {
   background-color: rgba(0, 0, 0, .05);
 }
</style>